import { createSlice } from "@reduxjs/toolkit";

const spinnerInitialState = {
  spinnerFlag: false,
  spinnerText: "",
};

const SpinnerReduer = createSlice({
  name: "spinnerReducer",
  initialState: spinnerInitialState,
  reducers: {
    updateSpinnerFlag(state, action) {
      state.spinnerFlag = action.payload;
    },
    updateSpinnerText(state, action) {
      state.spinnerText = action.payload;
    },
  },
});
export const SpinnerReduerAction = SpinnerReduer.actions;
export default SpinnerReduer.reducer;
